<div class="form-group" [formGroup]="formGroup">
    <label *ngIf="title">{{title}} {{control | controlRequiredText}}
    </label>

    <div [class.disabled]="control.disabled" [class.dropdown-lg]="size === 'lg'"
        class="dropdown dropdown-filter dropdown-input-filter dropdown-one-line-txt-btn" [id]="id + '-dp'">
        <button [class.data-required]="control.touched && control.invalid"
            class="btn dropdown-toggle dropdown-toggle-no-arrow" type="button" [id]="id" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">

            {{placeholder}}




        </button>
        <div class="dropdown-menu dropdown-menu-filter dropdown-input-tag-collapse ">
            <div class="mgn-bottom-10">
                <label [for]="id + '-search'" class="accesibleHidden">{{placeholderSearch}}</label>
                <input type="text" class="form-control filter-input" [id]="id + '-search'"
                    [placeholder]="placeholderSearch" />
            </div>

            <div class="no-result-ctn d-none">
                <label>No se encontraron resultados</label>
            </div>

            <div class="collapse-fieldset-group">

                <ng-container *ngFor="let e of dataSelect; let i = index">

                    <div [class.display-none]="e?.enabled === false" class="collapse-fieldset">

                        <div class="fieldset-header group-heading">
                            <a data-toggle="collapse" href=""><i
                                    class="pj-ico pj-ico-flecha-colapsable"></i>{{e.parent}}</a>
                        </div>
                        <div class="fieldset-body show">

                            <div class="checkbox-group" [id]="id + '-group-' + i">

                                <div class="wrap-checkbox" [class.d-none]="!textSelectAllGroup">
                                    <label class="checkbox-label every-checkbox" [for]="id + '-all-' + i">
                                        <input class="every-check" type="checkbox" [id]="id + '-all-' + i"
                                            (change)="onChangeCheckboxAll($event, i)" />
                                        <span class="checkmark"></span>
                                        {{textSelectAllGroup}}
                                    </label>
                                </div>

                                <div class="wrap-checkbox"
                                    *ngFor="let s of control.at(i).get('items').controls; let j = index">
                                    <label class="checkbox-label" [for]="id + '-' + j + '-' + i">
                                        <input class="custom-single-check" type="checkbox" [id]="id + '-' + j + '-' + i"
                                            (change)="onChangeCheckbox($event, i)" [formControl]="s" />
                                        <span class="checkmark"></span>
                                        {{ dataSelect[i].items[j].child }}
                                    </label>
                                </div>

                            </div>
                        </div>
                    </div>

                </ng-container>
            </div>
        </div>
    </div>

    <div-validation-message [control]="control" [messageRequired]="messageRequired"></div-validation-message>

    <small *ngIf="footer" class="form-text text-muted" [innerHTML]="footer"></small>
</div>